import React, { CSSProperties, FC, ReactNode } from 'react';
import { useMeasure } from 'react-use';

interface IFooterProps {
	children: ReactNode;
	// eslint-disable-next-line react/require-default-props
	style?: CSSProperties;
}
const Footer: FC<IFooterProps> = ({ children, style }) => {
	const [ref, { height }] = useMeasure<HTMLDivElement>();

	const root = document.documentElement;
	root.style.setProperty('--footer-height', `${height}px`);

	return (
		<footer ref={ref} className='footer' style={style}>
			{children}
		</footer>
	);
};

export default Footer;
